import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { ClearProfilePhotoRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { ClearProfilePhotoResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const clearProfilePhoto = (request: ClearProfilePhotoRequest, options?: CashRequestOptions) =>
  post<ClearProfilePhotoRequest, ClearProfilePhotoResponse>('/2.0/cash/clear-profile-photo', request, {
    ...options,
    rejectOnError: true,
  })
